import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';

const messages = [
  'Our support team has been notified!',
  'You could try again later?',
];

const Error = ({ error }) => (
  <div>
    <Message
      error
      header="Ooops.... we've had a problem loading your shortlist"
      list={messages}
    />
    <Message
      header="Error details"
      content={error.message}
    />
  </div>
);

Error.propTypes = {
  error: PropTypes.object.isRequired,
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/error/index.js